import './js/data-tables/learndash-reporting-courses'
import './js/data-tables/learndash-reporting-users'
import './js/data-tables/general'
import './css/index.scss'
